import { useEffect, useState } from 'react';
import { cls } from '../lib/util';

/** A tumbling d20 that settles on `value`. `need` shows the target and colours the result. */
export function D20({ value, need, ok, reason, reduced }: { value: number; need?: number; ok?: boolean; reason: string; reduced?: boolean }) {
  const [shown, setShown] = useState(reduced ? value : 1);
  const [settled, setSettled] = useState(reduced);
  useEffect(() => {
    if (reduced) return;
    let n = 0;
    const t = setInterval(() => { n++; setShown(1 + Math.floor(Math.random() * 20)); if (n >= 9) { clearInterval(t); setShown(value); setSettled(true); } }, 70);
    return () => clearInterval(t);
  }, [value, reduced]);
  return (
    <div className={cls('d20wrap', settled && 'settled', settled && ok != null && (ok ? 'ok' : 'fail'))} role="img" aria-label={`${reason}: rolled ${value}${need ? ` needing ${need}` : ''}`}>
      <div className={cls('d20', !settled && !reduced && 'tumble')}>
        <svg viewBox="0 0 100 100" aria-hidden="true"><polygon points="50,4 93,28 93,72 50,96 7,72 7,28" /><polygon className="inner" points="50,22 76,37 76,63 50,78 24,63 24,37" /></svg>
        <span className="face">{shown}</span>
      </div>
      <div className="d20label">{reason}{need ? <small> · need {need}+</small> : null}</div>
    </div>
  );
}

export function Coins({ heads, reduced }: { heads: number; reduced?: boolean }) {
  const total = heads + 1;
  return (
    <div className="coins" role="img" aria-label={`${heads} heads then tails`}>
      {Array.from({ length: Math.min(total, 8) }, (_, i) => (
        <span key={i} className={cls('coin', i < heads ? 'heads' : 'tails', !reduced && 'flip')} style={{ animationDelay: `${i * 0.18}s` }}>{i < heads ? 'H' : 'T'}</span>
      ))}
      <div className="d20label">Blob Bear: {heads} heads → +{heads * 2}</div>
    </div>
  );
}
